var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('base-container',{class:["cube-radio-modal-page"]},[_c('radio-modal-default',{class:["demo-item"]}),_c('radio-modal-option-conf',{class:["demo-item"]}),_c('radio-modal-cancel-btn',{class:["demo-item"]}),_c('radio-modal-slots',{class:["demo-item"]})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }